import React from "react";
import cls from "classnames";

import styles from "./styles.scss";

export default function LoadMore({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div className={cls(styles.wrap, className)} {...rest}>
      <div className={styles.loading}>
        <span className={`${styles.item} ${styles.item_1}`}></span>
        <span className={`${styles.item} ${styles.item_2}`}></span>
        <span className={`${styles.item} ${styles.item_3}`}></span>
        <span className={`${styles.item} ${styles.item_4}`}></span>
        <span className={`${styles.item} ${styles.item_5}`}></span>
        <span className={`${styles.item} ${styles.item_6}`}></span>
        <span className={`${styles.item} ${styles.item_7}`}></span>
        <span className={`${styles.item} ${styles.item_8}`}></span>
      </div>
    </div>
  );
}
